import { createCtx } from "../hooks/createCtx";

export type ClientContext = {
  clientId: string | null | undefined;
  setClientId: React.Dispatch<React.SetStateAction<string | null | undefined>>;
};

export const [useClientContext, ClientContextProvider] =
  createCtx<ClientContext>();
